import { assetUrl } from '@/shared/utils/assetUrl'

type EnrollmentDetailItem = {
  label: string
  value: string
  iconPath: string
  iconAlt: string
  accentClassName: string
  iconBackgroundClassName: string
}

type EnrollmentDetailsSummaryProps = {
  data: {
    programType: string
    location: string
    startDate: string
    schedule: string
  }
}

const detailItems = (data: EnrollmentDetailsSummaryProps['data']): EnrollmentDetailItem[] => [
  {
    label: 'Program Type',
    value: data.programType,
    iconPath: '/assets/icons/award.svg',
    iconAlt: 'Program',
    accentClassName: 'text-primary',
    iconBackgroundClassName: 'bg-primary'
  },
  {
    label: 'Location',
    value: data.location,
    iconPath: '/assets/icons/location-white.svg',
    iconAlt: 'Location',
    accentClassName: 'text-yellow-700',
    iconBackgroundClassName: 'bg-yellow-500'
  },
  {
    label: 'Start Date',
    value: data.startDate,
    iconPath: '/assets/icons/calendar-white.svg',
    iconAlt: 'Start Date',
    accentClassName: 'text-blue-700',
    iconBackgroundClassName: 'bg-blue-500'
  },
  {
    label: 'Schedule',
    value: data.schedule,
    iconPath: '/assets/icons/clock-white.svg',
    iconAlt: 'Schedule',
    accentClassName: 'text-green-700',
    iconBackgroundClassName: 'bg-green-500'
  }
]

export function EnrollmentDetailsSummary({ data }: EnrollmentDetailsSummaryProps) {
  const items = detailItems(data)

  return (
    <div className="mt-10 flex w-full flex-col items-center">
      <div className="flex w-full max-w-3xl flex-col gap-6 md:flex-row md:justify-center">
        {items.map((item, index) => (
          <div key={item.label} className="contents">
            <div className="flex min-w-[160px] flex-1 flex-col items-center">
              <div
                className={`mb-2 flex h-12 w-12 items-center justify-center rounded-full ${item.iconBackgroundClassName}`}
              >
                <img
                  src={assetUrl(item.iconPath)}
                  alt={item.iconAlt}
                  className="h-7 w-7"
                />
              </div>
              <div className={`mb-1 text-xs font-semibold uppercase tracking-wide ${item.accentClassName}`}>
                {item.label}
              </div>
              <div className="whitespace-pre-line text-center text-base font-bold text-gray-900">
                {item.value}
              </div>
            </div>
            {index < items.length - 1 ? (
              <div className="hidden flex-col items-center justify-center md:flex">
                <div className="h-10 w-1 rounded-full bg-gray-200" />
              </div>
            ) : null}
          </div>
        ))}
      </div>
    </div>
  )
}
